import get from 'lodash/get';

import sizeFormat from './sizeFormat';
import moment     from "moment";

export const getMeta = (item) => ({
  totalPages: get(item, 'total_pages') || 0,
  totalItems: get(item, 'total_count') || 0,
  current: get(item, 'page') ? get(item, 'page') + 1 : 1,
  perPage: get(item, 'size') || 1
});

export const getFile = (item) => ({
  id: get(item, 'id') || '',
  uuid: get(item, 'uuid') || '',
  name: get(item, 'file_name') || '',
  size: sizeFormat(get(item, 'size') || 0),
  extension: get(item, 'extension') || ''
});

export const getMultiName = (item) => ({
  uz: get(item, 'uz') || '',
  oz: get(item, 'oz') || '',
  ru: get(item, 'ru') || '',
  en: get(item, 'en') || ''
});

export const getIdAndName = (item) => ({
  id: get(item, 'id') || '',
  name: get(item, 'name') || ''
});

export const getIdAndMultiName = (item) => ({
  id: get(item, 'id') || '',
  name: getMultiName(get(item, 'name'))
});

export const getOrganization = (item) => ({
  id: get(item, 'id') || '',
  type: get(item, 'type') || '',
  name: getMultiName(get(item, 'name'))
});

export const getFunction = (item) => ({
  id: get(item, 'id') || '',
  name: getMultiName(get(item, 'name')),
  code: get(item, 'code') || 0,
  link: get(item, 'link') || ''
});

export const getBasisType = (item) => ({
  id: get(item, 'id') || '',
  lexId: get(item, 'lex_id') || '',
  name: getMultiName(get(item, 'name'))
});

export const getTask = (item) => ({
  id: get(item, 'id') || '',
  title: getMultiName(get(item, 'title')),
  links: (get(item, 'links') || []).map(getNameAndLink),
  file: getFile(get(item, 'file_response'))
});

export const getFunctionUser = (item) => ({
  id: get(item, 'id') || '',
  name: get(item, 'name') || ''
});

export const getReestrProject = (item) => ({
  id: get(item, 'reestr_project_id') || '',
  fullName: get(item, 'full_name') || '',
  shortDescription: get(item, 'short_description') || '',
  target: get(item, 'target') || '',
  tasks: get(item, 'tasks') || '',
});

export const getNameAndLink = (item) => ({
  name: get(item, 'name') || '',
  link: get(item, 'link') || ''
});

export const getServicePoint = (item) => ({
  id: get(item, 'id') || '',
  name: get(get(item, 'service_point', ''), 'name') || '',
  file: getFile(get(get(item, 'service_point'), 'file_response')),
  link: get(item, 'link') || ''
});

export const MapLexData = (item = {}, extraFields = {}) => ({
  id: get(item, 'id') || 0,
  content: getMultiName(get(item, 'content')),
  link: get(item, 'link') || '',
  documentTypeId: get(item, 'document_type_id') || null,
  docNumber: get(item, 'doc_number') || '',
  docName: get(item, 'doc_name') || '',
  displayNameForm: get(item, 'display_name_form') || '',
  number: get(item, 'number') || null,
  lexId: get(item, 'lex_id') || null,
  elementId: get(item, 'element_id') || null,
  orderIndex: get(item, 'order_index') || null,
  basisDate: get(item, 'basis_date')
             ? moment(get(item, 'basis_date').split('T')[0], 'YYYY-MM-DD').format('DD.MM.YYYY')
             : '',
  acceptDate: get(item, 'accept_date') || '',
  changeDate: get(item, 'change_date') || '',
  ...extraFields
});

export const MapLexDataList = (list = [], getExtraFields) =>
  list.map(item => MapLexData(item, getExtraFields ? getExtraFields(item) : {}));
